import { useRef } from "react";
import { FooterButtonGroup, FooterButton } from "./footer";
import WalkthroughTipPresenter from "frontend/walkthrough-tips/walkthrough-tip-presenter";
import { TipName } from "shared/datamodel/schemas";

export function CommentButton({ onClick, loading }: { onClick: () => void; loading: boolean }) {
  const buttonRef = useRef<HTMLDivElement>(null);
  return (
    <FooterButtonGroup>
      <FooterButton
        tooltip={loading ? "Loading comments..." : "Comment"}
        onClick={onClick}
        disabled={loading}
        ref={buttonRef}
        testid={"Comment"}
      >
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ color: loading ? "#AFB3BF" : "#113357" }}
        >
          <path
            d="M2.5459 0.636719H17.8232C18.8778 0.636753 19.7323 1.49139 19.7324 2.5459V12.6631C19.7323 13.7177 18.8778 14.5722 17.8232 14.5723H6.03125C5.36869 14.5723 4.72492 14.7793 4.18848 15.1602L3.96484 15.334L1.68652 17.2793C1.27341 17.6317 0.63696 17.3379 0.636719 16.7949V2.5459C0.636866 1.49146 1.49146 0.636865 2.5459 0.636719Z"
            stroke="currentColor"
            strokeWidth="1.27308"
          />
          <path
            d="M4.68481 5.07422H16.0917"
            stroke="currentColor"
            strokeWidth="1.27308"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.68481 9.14844H12.8326"
            stroke="currentColor"
            strokeWidth="1.27308"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </FooterButton>
      <WalkthroughTipPresenter tipName={TipName.walkthroughDropComment} attachToRef={buttonRef} />
    </FooterButtonGroup>
  );
}
